export const styles = {
	cardContainer: {
		margin: 8,
		borderRadius: 20,
		cursor: 'pointer',
		maxWidth: 300
	},
	topCardContainer: {
		padding: '10px 20px',
		flexDirection: 'column',
		borderRadius: '16px 16px 8px 8px',
		border: '1px solid black',
		borderBottom: '1px dashed black',
		boxShadow: '10px 10px 10px grey'
	},
	bottomCardContainer: {
		justifyContent: 'space-evenly',
		alignItems: 'center',
		padding: '20px',
		borderRadius: '8px 8px 16px 16px',
		border: '1px solid black',
		borderTop: 0,
		boxShadow: '10px 10px 10px grey'
	}
};

export const colorsSet = [
	{	//United
		backgroundColor: '#032B92',
		color: '#EDFFFF',
		secondaryColor: '#FEFF97'
	},
	{	//Lufthansa
		backgroundColor: '#FFAC2C',
		color: '#2D2C2C',
		secondaryColor: '#5B5B5B'
	},
	{	//Delta
		backgroundColor: '#08032D',
		color: '#C4C3E8',
		secondaryColor: '#FEFF97'
	},
	{	//Alitalia
		backgroundColor: '#005C3D',
		color: '#F7F7F7',
		secondaryColor: '#FEFEA4'
	},
	{	//Southwest
		backgroundColor: '#344CAC',
		color: '#F1F2F5',
		secondaryColor: '#F2C04C'
	},
	{	//EasyJet
		backgroundColor: '#ED6D34',
		color: '#FCEFE8',
		secondaryColor: '#783718'
	},
	{	//Emirates
		backgroundColor: '#FFFFFF',
		color: '#545454',
		secondaryColor: '#C72F32'
	},
	{	//Qantas
		backgroundColor: '#B42B2F',
		color: '#EFDEE0',
		secondaryColor: '#EFDEE0'
	}
];